import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import image1 from '../../images/g1.jpg';
import image2 from '../../images/g2.jpg';
import image3 from '../../images/g3.png';
import image4 from '../../images/g4.jpg';

import thumb1 from '../../images/thumb 1.jpg';
import thumb2 from '../../images/thumb 2.jpg';
import thumb3 from '../../images/thumb 3.jpg';
import thumb4 from '../../images/thumb 4.jpg';

const images = [
  { id: 'EB 2041 LV', src: image1, thumb: thumb1 },
  { id: 'EB 2033 RE', src: image2, thumb: thumb2 },
  { id: 'SF 1096', src: image3, thumb: thumb3 },
  { id: 'EB 2030 RE', src: image4, thumb: thumb4 },
];

export default function Gallery() {
  const [currentImage, setCurrentImage] = useState(images[1]);

  const goToPrevious = () => {
    const currentIndex = images.findIndex(img => img.id === currentImage.id);
    const prevIndex = (currentIndex - 1 + images.length) % images.length;
    setCurrentImage(images[prevIndex]);
  };

  const goToNext = () => {
    const currentIndex = images.findIndex(img => img.id === currentImage.id);
    const nextIndex = (currentIndex + 1) % images.length;
    setCurrentImage(images[nextIndex]);
  };

  return (
    <div className="w-full max-w-[1200px] mx-auto p-4 py-16">
      <h2 className="text-center text-2xl md:text-4xl font-bold mb-6">Showcasing Products</h2>
        <p className="text-gray-600 max-w-2xl text-center mb-10 mx-auto text-sm md:text-base">
        Explore a handpicked selection of our best-selling and most innovative products. Each piece highlights our dedication to quality, design, and customer satisfaction
        </p>

      <div className="relative bg-white rounded-xl overflow-hidden shadow-lg h-[60vh]">
        <img
          src={currentImage.src}
          alt={currentImage.id}
          className="w-full h-full object-cover rounded-xl"
        />
        <button onClick={goToPrevious} className="absolute top-1/2 left-4 transform -translate-y-1/2 bg-white p-2 rounded-full shadow">
          <ChevronLeft />
        </button>
        <button onClick={goToNext} className="absolute top-1/2 right-4 transform -translate-y-1/2 bg-white p-2 rounded-full shadow">
          <ChevronRight />
        </button>
      </div>
      <div className="mt-6 flex justify-center gap-4">
        {images.map((img) => (
          <button
            key={img.id}
            onClick={() => setCurrentImage(img)}
            className={`border-2 rounded p-1 ${currentImage.id === img.id ? 'border-gray-500' : 'border-transparent'}`}
          >
            <img src={img.thumb} alt={img.id} className="h-20 w-20 object-cover rounded" />
            <p className="text-center text-sm mt-1">{img.id}</p>
          </button>
        ))}
      </div>
    </div>
  );
}
